var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right_nav"},[_c('el-backtop',{staticClass:"backtop-layout",attrs:{"target":"#__nuxt","icon":"el-icon-arrow-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }